// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import * as mixins from 'view/styles/mixins';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

// Progress Bar - Replace with AtlasKit version when available
const progressBarHeight = '6px';

interface UploadProgressProps {
    progress: number;
}

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const UploadProgressBar = styled.div`
    ${mixins.borderRadius};
    height: ${progressBarHeight};
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const UploadProgressBarInProgress = UploadProgressBar.extend`
    width: ${(props: UploadProgressProps) => props.progress || 0}%;
    background: ${token('color.background.neutral.bold', colors.N800)};
`;

export const UploadProgressBarFailure = UploadProgressBar.extend`
    width: 100%;
    background: ${token('color.background.danger.bold', colors.R300)};
`;
